<template>
  <div class="vx-row">
    <div class="vx-col w-full md:w-2/3 mb-base">
      <vx-card title="Revenue">
        <template slot="actions">
          <feather-icon icon="SettingsIcon" svgClasses="w-6 h-6 text-grey"></feather-icon>
        </template>
        <div slot="no-body" class="p-6 pb-0">
          <div class="flex">
            <div class="mr-6">
              <p class="mb-1 font-semibold">This Month</p>
              <p class="text-3xl text-success"><sup class="text-base mr-1">$</sup>86,589</p>
            </div>
            <div>
              <p class="mb-1 font-semibold">Last Month</p>
              <p class="text-3xl"><sup class="text-base mr-1">$</sup>73,683</p>
            </div>
          </div>
          <vue-apex-charts type=line height=266 :options="analyticsData.revenueComparisonLine.chartOptions"
                           :series="analyticsData.revenueComparisonLine.series"/>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
  import VueApexCharts from 'vue-apexcharts'
  import analyticsData from './ui-elements/card/analyticsData.js'

  export default {
    data(){
      return {
        analyticsData: analyticsData,
      }
    },
    components: {
      VueApexCharts
    }
  }
</script>

<style scoped>

</style>
